import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ServerUrlService } from 'src/app/services/server-url.service';
import { AddAnexoModalComponent } from '../add-anexo-modal/add-anexo-modal.component';

@Component({
  selector: 'app-anexo',
  templateUrl: './anexo.component.html',
  styleUrls: ['./anexo.component.scss']
})
export class AnexoComponent implements OnInit {

  @Input() accnum: number = 0
  otimusUrl: string = ''
  var0008: string = ''
  anexos: any[] = []
  deuErro: boolean = false

  constructor(private serverUrlService: ServerUrlService, private dialog: MatDialog) { }

  ngOnInit() {
    this.getAnexos()
  }

  async getAnexos() {
    try {
      if (!this.otimusUrl) {
        const reqCms = await fetch(`https://cms-backend.otimusclinic.com/variables/host/${this.serverUrlService.getName()}`, {
          method: 'POST'
        })
        const variables = await reqCms.json()
        this.otimusUrl = variables.find((el: any) => el.chave === 'Otimus_URL').valor
      }

      const reqAnexos = await fetch(`${this.otimusUrl}/api/v1/agendamento/${this.accnum}/anexos`)
      this.anexos = await reqAnexos.json()

      if (!this.var0008) {
        const reqVar8 = await fetch(`${this.otimusUrl}/global/var0008`)
        this.var0008 = (await reqVar8.json()).value
      }
    } catch (err) {
      console.error(err)
      this.deuErro = true
    }
  }

  baixarAnexo(anexo: any) {
    const splitName = anexo.GuiaAgendamentoViz.split('/')
    const filename = splitName[splitName.length - 1]
    const element = document.createElement('a')
    element.setAttribute('href', this.var0008 + anexo.GuiaAgendamentoViz)
    element.setAttribute('target', '_blank')
    element.setAttribute('download', filename)
    document.body.appendChild(element)
    element.click()
    document.body.removeChild(element)
  }

  async deletarAnexo(anexo: any) {
    const guiaAgendamentoId = anexo.GuiaAgendamentoID
    await fetch(`${this.otimusUrl}/api/v1/agendamento/${this.accnum}/anexos/${guiaAgendamentoId}`, {
      method: 'DELETE'
    })
    this.getAnexos()
  }

  addAnexoModal() {
    const dialogRef = this.dialog.open(AddAnexoModalComponent, {
      data: {
        accnum: this.accnum,
        otimusUrl: this.otimusUrl
      }
    })

    dialogRef.afterClosed().subscribe(() => {
      this.getAnexos()
    })
  }
}
